import { Checkbox, CheckboxProps, styled } from "@mui/material";

interface CustomCheckboxProps extends CheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  isParent?: boolean;
}

const StyledCheckbox = styled(Checkbox)({
  color: "var(--silver-500)",
  "&.Mui-checked": {
    color: "#55fa94",
  },
  "&.MuiCheckbox-indeterminate": {
    color: "#55fa94",
  },
  "&:hover": {
    backgroundColor: "rgba(168,230,207,0.1)",
  },
});

export const CustomCheckbox = ({
  indeterminate,
  checked,
  isParent,
  ...rest
}: CustomCheckboxProps) => {
  return (
    <StyledCheckbox
      checked={checked}
      indeterminate={isParent ? indeterminate : false}
      {...rest}
    />
  );
};
